  <div class="mt-1">
    <div class="row" style="margin-left: 10px;margin-right:10px">
      <div class="col-md-3">
        <h1>New Registration</h1>
      </div>
    </div>
  </div>
  <form #inwardregform="ngForm">
    <div id="accordion" class="accordion">
        <div class="card">
            <div id="headingOne" class="card-header bg-white border-0">
                <h5 class="mb-0 font-weight-bold"><a href="#" style="text-decoration: none;font-family: OpenSans SemiBold;color:#000" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" class="d-block position-relative text-dark collapsible-link py-2">General Information</a></h5>
            </div>
            <div id="collapseOne" aria-labelledby="headingOne" data-parent="#accordion" class="collapse show">
                <div id="dBox" class="card-body" style="padding:10px">
                    <div class="grid-item1">
                      <div class="from-group mt-1" >
                          <div class="form-group typeahead-wrap mt-1" style="width:100%">
                            <strong>DC No/Tax invoice <span class="required">*</span></strong>
                            <input type="text"  autocomplete="off" class="form-control mt-2"  name="dc" #dc="ngModel" id="dc" placeholder="Enter" ngModel required>
                            <div *ngIf="dc.invalid && (dc.dirty || dc.touched)" class="alert alert-danger">
                              <div class="mt-2" *ngIf="dc.errors.required" >
                                DC No/Tax Invoice is required.
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                    <div class="grid-item2">
                        <div class="form-group mt-1">
                          <strong>Registration Type <span class="required">*</span></strong>
                            <div class="form-group typeahead-wrap mt-1" style="width:100%">
                              <ngx-select [items]="transactionMasterData" optionValueField="transactionStatusId" optionTextField="name" 
                                placeholder="Select" class="ngxdropdown" name="regType" id="regType" #regType="ngModel"
                                (select)="ReturnSelected" [(ngModel)]="ReturnSelected" [noAutoComplete]="false"        
                                (ngModelChange)="OnchangeReturnType($event)"
                                [ngModelOptions]="{standalone: true}" ngModel required>
                              </ngx-select>
                            </div>
                      </div>
                    </div>
                    <div class="grid-item3">
                      <div class="form-group mt-1">
                        <strong>Registration Date <span class="required">*</span></strong>
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                          <input type="text" class="form-control dpinputwidth" [ngModel]="dateInputData.StartDate"
                                 (ngModelChange)="dateInputData.StartDate=$event; validateRegistrationDate($event)" autocomplete="off" name="fromDate" id="fromDate"
                                 [minDate]="dateInputData.FromMinDate" [maxDate]="dateInputData.maxDate"
                                 [bsConfig]="{ containerClass: 'theme-default', showWeekNumbers: false }" placeholder="DD/MM/YYYY"
                                 placement="bottom left" #fromdate #fromDate="bsDatepicker" bsDatepicker>
                          <i class="icon-ic_calendar show-cursor" (click)="fromDate.toggle()">
                             </i>
                        </div>
                      </div>
                    </div>
                    <div class="grid-item4">
                      <div class="form-group mt-1">
                        <strong>Registration Time <span class="required">*</span></strong>
                        <!-- <div class="form-group typeahead-wrap mt-1" style="width:100%">
                          <input type="text" style="width:100%" class="form-control dpinputwidth" [ngModel]="dateInputData.StartDate"
                                 (ngModelChange)="dateInputData.StartDate=$event" autocomplete="off" name="fromDate" id="fromDate"
                                 [minDate]="dateInputData.FromMinDate" [maxDate]="dateInputData.maxDate"
                                 [bsConfig]="{ containerClass: 'theme-default', showWeekNumbers: false }" placeholder="MM/DD/YYYY"
                                 placement="bottom left" #fromdate #fromDate="bsDatepicker" bsDatepicker>
                          <i class="icon-ic_calendar show-cursor" (click)="fromDate.toggle()">
                             </i>
                        </div> -->
                        <div class="typeahead-wrap-clock">
                          <ng-template #fromtimetemplate>
                            <timepicker [(ngModel)]="fromtimepickervalue" (click)="$event.stopPropagation();"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="fromTimePickerValueChanges($event)"
                                        (isValid)="isValid($event)" [minuteStep]="msstep"></timepicker>
                          </ng-template>
                          <input style="width: 100%;border: 1px solid #d0d0ce;" value="fromtimevalue" readonly #fromtime name="ftime" [(ngModel)]="fromtimevalue" >
                          <span class="icon-ic_time" style="cursor: pointer;" [popover]="fromtimetemplate" [outsideClick]="true" placement="bottom"></span>
                        </div>
                        <div *ngIf="!isValidTime" class="alert alert-danger">Please provide valid time</div>
                      </div>
                    </div>
                    
                    <div class="grid-item3" *ngIf="(this.ReturnSelected == InwardStatus.Returnable || this.ReturnSelected == InwardStatus.InternalMovement)">
                      <div class="form-group mt-1">
                        <strong>Return Date <span class="required">*</span></strong>
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                          <input type="text" class="form-control dpinputwidth" [ngModel]="dateInputData.EndDate"
                                 (ngModelChange)="dateInputData.EndDate=$event; validateReturnDate($event)" autocomplete="off" name="toDate" id="toDate"
                                 [minDate]="dateInputData.StartDate" [maxDate]="dateInputData.maxToDate"
                                 [bsConfig]="{ containerClass: 'theme-default', showWeekNumbers: false }" placeholder="MM/DD/YYYY"
                                 placement="bottom left" #todate #toDate="bsDatepicker" bsDatepicker>
                          <i class="icon-ic_calendar show-cursor" (click)="toDate.toggle()">
                             </i>
                        </div>
                      </div>
                    </div>
                    <div class="grid-item4" *ngIf="(this.ReturnSelected == InwardStatus.Returnable || this.ReturnSelected == InwardStatus.InternalMovement)">
                      <div class="form-group mt-1">
                        <strong>Return Time <span class="required">*</span></strong>
                        <div class="typeahead-wrap-clock">
                          <ng-template #totimetemplate>
                            <timepicker [(ngModel)]="totimepickervalue" (click)="$event.stopPropagation();"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="toTimePickerValueChanges($event)"
                                        (isValid)="isValid($event)" [minuteStep]="msstep"  ></timepicker>
                          </ng-template>
                          <input style="width: 100%;border: 1px solid #d0d0ce;" value="totimevalue" readonly #totime name="ttime" [(ngModel)]="totimevalue" >
                          <span class="icon-ic_time" style="cursor: pointer;" [popover]="totimetemplate" [outsideClick]="true" placement="bottom"></span>
                        </div>
                        <div *ngIf="!isValidTime" class="alert alert-danger">Please provide valid time</div>
                      </div>
                    </div>
                    
                    <div>
                      <div class="from-group mt-1" >
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                          <strong>Brought from<span class="required">*</span></strong>
                          <input type="text" autocomplete="off" class="form-control mt-2"  name="brfrom" #brfrom="ngModel" id="brfrom" placeholder="Search By Name" ngModel required>
                          <!-- <input [(ngModel)]="selectedValue"
                          [typeahead]="broughtFromList"
                          typeaheadOptionField="name"
                          (typeaheadOnSelect)="onSelect($event)"
                          (ngModelChange)="onChangename($event)"
                          [typeaheadScrollable]="true"
                          name="brfrom"
                          #brfrom="ngModel"
                          id="brfrom"
                          placeholder="Search By Name"
                          [typeaheadOptionsInScrollableView]="5"
                          class="form-control mt-2"
                          autocomplete="off"> -->
                          <div *ngIf="brfrom.invalid && (brfrom.dirty || brfrom.touched)" class="alert alert-danger">
                            <div class="mt-2" *ngIf="brfrom.errors.required" >
                              Brought from is required.
                            </div>
                          </div>
                        </div>
                    </div>
                    </div>
                    
                    <div class="grid-item6"> 
                      <div class="from-group mt-1" >
                        <div class="form-group typeahead-wrap mt-1" style="width:100%"> 
                          <strong >Recipient's Email<span class="required"> *</span></strong> 
                          <input type="text" autocomplete="off" class="form-control mt-2"  minlength="3" [typeahead]="requestorNameDataSource" 
                          [typeaheadMinLength]="3" [typeaheadScrollable]="true" [typeaheadItemTemplate]= "requestorCustTemp"
                          (typeaheadLoading)="changeRequestorTypeaheadLoading($event)" typeahead-focus-first=true
                          (typeaheadOnSelect)="requestorNameOnSelect($event)" (typeaheadNoResults)="typeaheadTravelerNoResults($event)"
                          [typeaheadOptionsInScrollableView]="5" typeaheadOptionField="EmployeeFullName" [(ngModel)]="EmployeeFullName"
                          name="EmployeeFirstName" #requestorName="ngModel" id="requestorName" autocomplete="off"  [ngModelOptions]="{standalone: true}"
                          placeholder="Search by Email ID " (keyup)="searchClient(EmployeeFullName)" required>
                          <span ng-bind="EmployeeFullName"></span>

                          <img src="../assets/images/spinner.gif" *ngIf="typeaheadRequestorLoading" class="loader">
                          <div class="alert alert-danger" style="position: absolute;" [hidden]="!noResultTravelerName">No results found </div>
                          <div *ngIf="requestorName.invalid && (requestorName.dirty || requestorName.touched)" class="alert alert-danger">
                            <div class="mt-2" *ngIf="requestorName.errors.required" >
                              Email ID is required.
                            </div>
                          </div>

                          <ng-template #requestorCustTemp let-model="item" let-index="index">
                            <div (click)="onselectClient(model)">
                              <span>{{model.displayName}}</span>
                              <br>
                              <span>{{model.mail}}</span>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div> 
                    
                    <div class="grid-item8">
                      <div class="from-group mt-1" >
                        <div class="form-group typeahead-wrap mt-1" style="width:100%"> 
                          <strong >City<span class="required"> *</span></strong>
                          <div>
                            <ngx-select 
                            [items]="cityData" optionValueField="cityID" optionTextField="cityName" placeholder="Select City"
                            (select)="selectCity()" [(ngModel)]="CitySelected" [noAutoComplete]="false" (ngModelChange)="OnchangeCity($event)"
                            [ngModelOptions]="{standalone: true}" required>
                            </ngx-select> 
                          </div>
                        </div>
                      </div>
                    </div> 

                    <div class="grid-item9">
                      <div class="from-group mt-1" >
                        <div class="form-group typeahead-wrap mt-1" style="width:100%"> 
                          <strong >Office<span class="required"> *</span></strong>
                          <div>
                            <ngx-select [items]="officeData" id="office" name="office" optionValueField="officeID" optionTextField="officeName" 
                            placeholder="Select Office" (select)="OfficeDetails.officeID" [(ngModel)]="OfficeSelected" 
                            [noAutoComplete]=false [ngModelOptions]="{standalone: true}" (ngModelChange)="OnOfficeChange($event)"
                            required>
                            </ngx-select>
                          </div>
                        </div>
                      </div>
                    </div> 

                    <div class="grid-item7">
                        <strong>Remarks</strong>
                        <div class="form-group">
                          <textarea style="resize: none;" name="remarks" #remarks="ngModel" class="form-control" rows="4" id="remarks" ngModel></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </form>

    <!-- Materials DropDown -->
    <!-- <div id="headingOne" class="card-header bg-white border-0">
      <h4 class="mb-0 font-weight-bold"><span style="text-decoration: none;font-family: OpenSans SemiBold;color:#000" class="d-block position-relative text-dark py-2">Materials</span></h4>
    </div> -->
   
    <div class="mt-1">
      <div *ngIf="attachedFiles.length > 0">
        <div class="col-md-3" style="margin-top: 10px;">
        <h3>Attached Files:</h3>
        </div>
        <ul>
          <li *ngFor="let file of attachedFiles; let i = index">
            {{ file.name }}
            <img src="assets/images/delete.png" alt="Delete" width="16" height="16" (click)="deleteFile(i)" style="cursor: pointer;margin-left: 20px;">
          </li>
        </ul>
      </div>
      <div class="row" style="margin-top:30px;margin-left: 10px;margin-right:10px">
        <div class="col-md-3">
          <h3 >Materials</h3>
        </div>
        <div class="col-md-9 d-flex justify-content-end">
          <!-- <div class="importMat">
            <input type="file" name="file" class="custom-file-input" id="inputGroupFile" required (change)="handleImport($event)"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
          </div> -->
          <div class="addMat" (click)="addMaterial()">
            <span>Add Material</span>
          </div>
          <div class="upload-material" (click)="UploadMaterial()" [ngClass]="{'disabled': attachedFiles.length == 3}">
            <span >Upload Material</span>
          </div>
        </div>
    </div>
    <app-upload-material *ngIf="showUploadMaterial" (close)="closeUploadMaterial()"  (fileData)="handleFileData($event)"></app-upload-material>
    </div>
    
    <!-- Table Material -->
    <div class="card" style="margin-top: 10px;margin-bottom: 80px;margin-left:10px;margin-right:10px;border: 0px;">
      <div [ngClass]="{'scrollable':this.materialList.length > 4}"> 
        <table class="demTable">
          <thead>
            <tr>
              <th>S.No.</th>
              <th width="40%">Description<span class="required"> *</span></th>
              <th>Required Quantity<span class="required"> *</span></th>
              <th width="30%">Notes</th>
              <th></th>
            </tr>
            <tr class="table-row" *ngFor="let material of materialList;let i = index">
              <td>&nbsp;<span>{{i+1}}</span></td>
              <td>
                <div class="BoxOne">
                  <input type="text" [(ngModel)]="material.Name"  name="matName" #matName="ngModel" id="matName" autocomplete="off" class="form-control mt-0" placeholder="Enter">
                </div>
              </td>
              <td>
                <div class="BoxTwo">
                  <input type="number" style="position:relative;top:3px;left:10px;" [(ngModel)]="material.Quantity" name="matQuan" #matQuan="ngModel" id="matQuan" autocomplete="off" class="form-control mt-0" placeholder="Enter">
                  <div class="BoxFour">
                    <div class="UpArrow"><img src="../../../../assets/images/UpArrow.png" (click)="increase(i)" style="height: 8px;width: 10px;" class="show-cursor" [alt]=""/></div>
                    <div class="DownArrow"><img src="../../../../assets/images/DownArrow.png" (click)="decrease(i)" style="height: 8px;width: 10px;" class="show-cursor" [alt]=""/></div>
                  </div>
                </div>
              </td>
              <td>
                <div class="BoxOne">
                  <input type="text" [(ngModel)]="material.Notes" name="matNotes" #matNotes="ngModel" id="matNotes" autocomplete="off" class="form-control mt-0" placeholder="Enter">
                </div>
              </td>
              <td>
                <div class="BoxOne">
                  <img src="../../../../assets/images/delete.png" (click)='removeMaterial(i)' class="show-cursor" [alt]="X"/>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Footer -->
<footer class="page-footer" style="border-top: 1px solid #D0D0CE;">
  <button type="button" (click)="goBack()" style="background: #53565A;"><span>Cancel</span></button>
  &nbsp;&nbsp;
  <button type="button" [disabled]="showButton()" (click)="addInwardRequest(requestorName.value,dc.value,brfrom.value,remarks.value)" style="background: #007CB0;"><span>Register</span></button>
</footer>
<!-- Footer -->
